import React from 'react';
import { siteConfig } from '../data/siteConfig';
import { trackPixel } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  sublabel?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  sublabel,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const href = siteConfig.checkoutUrl || '#oferta';
  const sizes = {
    sm: 'whitespace-nowrap px-5 py-3.5 text-[15px] shadow-cta-sm',
    md: 'w-full max-w-[420px] px-5 py-[18px] text-base shadow-cta sm:w-auto sm:px-8 md:text-lg',
    lg: 'w-full max-w-[520px] px-5 py-5 text-[17px] shadow-cta sm:px-10 md:text-xl'
  };
  const handleClick = () => {
    if (!siteConfig.checkoutUrl) return;
    trackPixel('InitiateCheckout', {
      content_name: 'PASEO PRO',
      value: siteConfig.priceValue,
      currency: siteConfig.priceCurrency
    });
  };
  return <a href={href} target={siteConfig.checkoutUrl ? '_top' : undefined} onClick={handleClick} className={`inline-flex min-h-[48px] flex-col items-center justify-center gap-0.5 rounded-full bg-tangerine text-center font-display font-bold leading-tight text-white transition-[transform,box-shadow] duration-150 ease-out [text-wrap:balance] hover:-translate-y-0.5 active:translate-y-1 active:shadow-cta-pressed focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-tangerine-light ${sizes[size]} ${className}`} data-id="element-12" data-mp="159zwc648dadp">
      <span data-id="element-13" data-mp="3sxluws25j31t">{children}</span>
      {sublabel && <span className="text-[13px] font-medium opacity-90" data-id="element-14" data-mp="3swka3vvc326w">{sublabel}</span>}
    </a>;
}